<template>
  <div class="top_nav_item" @click="itemclick">
    <slot name="topnavimg"></slot>
    <slot name="topimgtext"></slot>

    <!--  修改昵称图片样式插槽大图标 配合下面的input使用-->
    <!-- input输入框插槽 -->
    <!-- <div
      class="config_nickName_input_wraper"
      v-if="this.$slots['config_nickName_input']"
    > -->
    <div
      class="config_nickName_input"
      v-if="this.$slots['config_nickName_input']"
    >
      <slot name="config_nickName_input"></slot>
      <slot name="config_nickName_xiugai"></slot>
    </div>

    <!-- </div> -->
    <!-- 界面管理  完成  退出 样式 -->
    <div class="config_jie_mian" v-if="this.$slots['config_jie_mian']">
      <slot name="config_jie_mian"></slot>
    </div>
    <!-- 行的开关按钮图片的插槽 -->
    <!-- <div
      class="config_hang_switchBtn_close"
      v-if="this.$slots['config_hang_switchBtn_close']"
    >
      <slot name="config_hang_switchBtn_close"></slot>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    path: {
      type: String,
      default: 'nullpath'
    }
  },
  methods: {
    itemclick() {
      ////顶部导航栏所有元素的点击事件
      console.log('itemclick11')
      console.log(this.path)
      if (this.path === 'nullpath') return
      this.$router.replace(this.path)
    }
    // xiugaiBtnHandle() {}
  }
}
</script>

<style>
.top_nav_item {
  flex: 1;
  text-align: center;
  height: 64px;
  line-height: 64px;
  font-size: 18px;
  color: #ffffff;
  cursor: pointer;

  /* padding-left: 20px;
  padding-right: 20px; */

  position: relative;
  /* display: flex;
  justify-content: center;
  align-items: center; */
}

.config_nickName_input input {
  background: none;
  border: none;
  font-size: 18px;
  width: 70%;

  text-align: center;
  color: #ffffff;
}
/* .config_nickName_xiugai {
  position: relative;
} */
.config_nickName_input img {
  width: 21px;
  height: 21px;

  position: relative;
  top: 4px;
  left: 5px;
}
/* .top_nav_img:after {
  content: '.';
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
  font-size: 0;
}
.top_nav_img {
  *zoom: 1;
} */

.main_topnav .top_nav_item:has(> .config_jie_mian) {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 60px;
}
.main_topnav .top_nav_item > .config_jie_mian {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  white-space: nowrap;
}
.config_jie_mian > div {
  flex: none;
  box-sizing: border-box;
  min-width: 64px;
  height: 40px;
  line-height: 40px;
  padding: 0 14px;
  margin: 0;
  border-radius: 8px;
  font-size: 16px;
  color: #fff;
  background: transparent;
  box-shadow: none;
  transition: background-color .15s;
}
.config_jie_mian > div:last-child {
  background: #eef2ff;
  color: #254c94;
  font-weight: 600;
}
.config_jie_mian > div:hover { background-color: rgba(255, 255, 255, .12); }
.config_jie_mian > div:last-child:hover { background-color: #fff; }
.config_jie_mian > div:active { opacity: .85; }

/* .config_nickName_input_wraper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
} */
</style>
